import { newATInternetPlugin, newGovoltePlugin, newPageTracker, newTag } from '@npotag/tag';
const npoTagPlugins = [newGovoltePlugin({ maxRetryCount: 5, delayBetweenRetriesInMs: 3000 }), newATInternetPlugin()];
export function initPlayerTracker(npoPlayer, _npoTag, _npoTagInstance, _npoTagPageTracker) {
    if (!npoPlayer.npoTag) {
        npoPlayer.npoTag = {
            npoTagInstance: undefined,
            pageTracker: undefined,
            heartbeatInterval: undefined
        };
    }
    if (!npoPlayer.npoTag?.npoTagInstance) {
        npoPlayer.npoTag.npoTagInstance = _npoTagInstance ?? (_npoTag ? newTag(_npoTag, npoTagPlugins) : undefined);
    }
    if (!npoPlayer.npoTag?.pageTracker && npoPlayer.npoTag?.npoTagInstance) {
        npoPlayer.npoTag.pageTracker = _npoTagPageTracker ?? newPageTracker(npoPlayer.npoTag.npoTagInstance);
    }
}
